import React from 'react';
import { Form, Spinner, Card, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

/**
 * SedeSelector - Component for selecting sede with auto-edit for incomplete sedes
 * @param {Object} props - Component props
 * @param {Array} props.listaSedes - List of all sedes
 * @param {Object} props.value - Selected sede object
 * @param {Function} props.onChange - Change handler receiving selected option
 * @param {Function} props.onEditar - Handler to open edit modal for sede
 * @param {boolean} props.loading - Loading state to show spinner
 * @param {string} props.clienteId - ID of selected cliente to filter sedes
 * @returns {JSX.Element}
 */
const SedeSelector = ({ listaSedes = [], value, onChange, onEditar, loading = false, clienteId, onCrearSede }) => {
    // Filter sedes by cliente

    console.log('listaSedes: ', listaSedes);
    const sedesFiltered = clienteId
        ? listaSedes.filter(s => s.cliente?._id === clienteId || s.cliente === clienteId)
        : [];

    // Format options for react-select with "Crear nueva sede..." at the top
    const options = [
        {
            value: '__crear_nueva__',
            label: '+ Crear nueva sede...',
            data: null
        },
        ...sedesFiltered.map(sede => ({
            value: sede._id,
            label: `${sede.nameSede || 'Sin nombre'} - ${sede.ciudad || 'Sin ciudad'}`,
            data: sede
        }))
    ];

    // Find selected option
    const selectedOption = value
        ? options.find(opt => opt.value === value._id)
        : null;

    const handleChange = (option) => {
        if (option?.value === '__crear_nueva__') {
            onCrearSede?.();
        } else {
            onChange(option?.data || null);
        }
    };

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label>
                    Sede *
                    {loading && <Spinner animation="border" size="sm" className="ms-2" />}
                </Form.Label>
                <Select
                    options={options}
                    value={selectedOption}
                    onChange={handleChange}
                    placeholder="Seleccione una sede..."
                    isClearable
                    isDisabled={!clienteId || loading}
                    noOptionsMessage={() => clienteId ? "No hay sedes disponibles" : "Primero seleccione un cliente"}
                    styles={{
                        option: (base, state) => ({
                            ...base,
                            fontWeight: state.data.value === '__crear_nueva__' ? 'bold' : 'normal',
                            color: state.data.value === '__crear_nueva__' ? '#0d6efd' : base.color
                        })
                    }}
                />
            </Form.Group>

            {value && (
                <Card className="mb-3 bg-light w-100">
                    <Card.Body className='w-100'>
                                <h6 className="mb-2">
                                    <i className="bi bi-building me-2"></i>
                                    {value.nameSede || 'Sin nombre'}
                                </h6>
                                <Row className="small text-muted">
                                    <Col lg={4}>
                                        <div className="mb-1">
                                            <i className="bi bi-geo-alt me-1"></i>
                                            {value.ciudad || 'Sin ciudad'}
                                            {value.departamento && ` - ${value.departamento}`}
                                        </div>
                                        {value.dirSede && (
                                            <div className="mb-1">
                                                <i className="bi bi-signpost me-1"></i>
                                                {value.dirSede}
                                            </div>
                                        )}
                                    </Col>
                                    <Col lg={3}>
                                        {value.contSede && (
                                            <div className="mb-1">
                                                <i className="bi bi-person me-1"></i>
                                                {value.contSede}
                                            </div>
                                        )}
                                        {value.celContacto && (
                                            <div className="mb-1">
                                                <i className="bi bi-telephone me-1"></i>
                                                {value.celContacto}
                                            </div>
                                        )}
                                    </Col>
                                    <Col lg={4}>
                                        {value.emailContacto && (
                                            <div className="mb-1">
                                                <i className="bi bi-envelope me-1"></i>
                                                {value.emailContacto}
                                            </div>
                                        )}
                                    </Col>
                                    <Col lg={1}>
                                    <div>
                                        <i 
                                            className="bi bi-pencil-square text-primary cursor-pointer" 
                                            style={{ fontSize: '1.2rem', cursor: 'pointer' }}
                                            onClick={() => onEditar(value)}
                                            title="Editar sede"
                                        ></i>
                                    </div>
                                    </Col>
                                </Row>                          
                    </Card.Body>
                </Card>
            )}
        </>
    );
};
export default SedeSelector;
